import React, { memo, useRef } from 'react';
import { connect } from 'react-redux';

import connectOptions, { mergeProps } from '../../utils/connectOptions';
import AddHarvcoTagPopup from '../../components/Popup/AddHarvcoTagPopup';
import { usePopupContext } from '../../contexts/PopupContext';

const AddHarvcoTagPopupContainer = ({ popup }) => {
  const { closePopup, startPopupLoading, endPopupLoading } = usePopupContext();
  const tagRef = useRef('');

  const handleChange = event => {
    const { name, value } = event.target;

    if (!name) return;
    tagRef.current = value;
  };

  const handleAddTag = () => {
    const handleAddTag = popup.getIn(['props', 'onAddTag'], () => {});
    const refreshGrid = popup.getIn(['props', 'refreshGrid'], () => {});

    handleAddTag(tagRef.current, {
      beforeStart: startPopupLoading,
      afterSuccess: () => {
        refreshGrid();
        endPopupLoading();
      },
      afterError: ({ responseBody }) => {
        endPopupLoading(responseBody);
      },
    });
  };

  return (
    <AddHarvcoTagPopup
      isPopupFetching={popup.get('isPopupFetching')}
      isPopupFetchingError={popup.get('isPopupFetchingError')}
      onAddTag={handleAddTag}
      onChange={handleChange}
      onClose={closePopup}
    />
  );
};

const AddHarvcoTagPopupContainerMemo = memo(AddHarvcoTagPopupContainer);

export { AddHarvcoTagPopupContainerMemo as AddHarvcoTagPopupContainer };
export default connect(() => ({}), {}, mergeProps, connectOptions)(AddHarvcoTagPopupContainerMemo);
